<div *ngIf="isVisible" class="footer-container">
  <div class="divider--wave"></div>

  <footer class="footer container" role="footer">
    <div class="footer-content">
      <div class="footer__text" *ngIf="footerText" [class.footer__text--nav]="footerLinks">
        <h5>{{ footerText.title }}</h5>
        <div [internalInnerHtml]="footerText.body" [userEventSource]="userEventSource"></div>
      </div>
      <nav class="footer-nav" *ngIf="footerLinks">
        <air-link-list [linkLists]="footerLinks" [userEventSource]="userEventSource"></air-link-list>
      </nav>
    </div>
    <div class="footer-end">
      <hr *ngIf="!theme" />
      <div class="footer-end__social" *ngIf="!theme">
        <h3>{{ "footer.social.header" | translate }}</h3>
        <div class="footer-end__social-buttons">
          <a
            class="button button--secondary-darker"
            [airLink]="'https://www.facebook.com/airmiles.nederland'"
            [userEventSource]="userEventSource"
            userEventLabel="Facebook"
            target="_system"
          >
            <span>{{ "footer.social.facebook" | translate }}</span>
            <i class="icon icon-social-facebook"></i>
          </a>
          <a
            class="button button--secondary-darker"
            [airLink]="'https://www.instagram.com/airmilesnederland'"
            [userEventSource]="userEventSource"
            userEventLabel="Instagram"
            target="_system"
          >
            <span>{{ "footer.social.instagram" | translate }}</span>
            <i class="icon icon-social-instagram"></i>
          </a>
        </div>
      </div>
      <hr />
      <div class="footer-end__nav">
        <air-link-list *ngIf="policyLinks" [linkLists]="policyLinks" [userEventSource]="userEventSource"></air-link-list>
        <div class="footer__pay-off pay-off"></div>
      </div>
    </div>
  </footer>
</div>
